// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
}

.text-viewer {
  overflow: auto;
  padding: 1em;
  white-space: pre-wrap;
}

.img-center {
  display: flex; /*for IE*/
  /*display: -webkit-box;*/
  align-items: center;
  justify-content: center;
}

.image-viewer {
  overflow: auto;
}
.image-viewer img {
  background: #fff;
  max-width: 100%;
  max-height: 100%;
}

.video-viewer {
  background-color: black;
}

.visible {
  visibility: visible;
}

.audio-viewer audio {
  min-width: 80%;
}

.mail-viewer {
  padding: 1em;
}

/* CANNOT-PREVIEW */
.can-not-preview {
  padding: 2em;
  text-align: center;
}
.preview-icon {
  opacity: .7;
  width: 160px;
  height: 160px;
  margin: auto;
}
.preview-error {
  color: #1b2733;
  font-size: 18px;
  margin: 8px;
}
.preview-error-info {
  color: #637282;
}
.preview-error-info span {
  margin: 0 8px;
}
.can-not-preview button {
  margin: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer-controller/file-viewer/file-viewer.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa,EAAE,SAAS;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.text-viewer {\n  overflow: auto;\n  padding: 1em;\n  white-space: pre-wrap;\n}\n\n.img-center {\n  display: flex; /*for IE*/\n  /*display: -webkit-box;*/\n  align-items: center;\n  justify-content: center;\n}\n\n.image-viewer {\n  overflow: auto;\n}\n.image-viewer img {\n  background: #fff;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.video-viewer {\n  background-color: black;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.audio-viewer audio {\n  min-width: 80%;\n}\n\n.mail-viewer {\n  padding: 1em;\n}\n\n/* CANNOT-PREVIEW */\n.can-not-preview {\n  padding: 2em;\n  text-align: center;\n}\n.preview-icon {\n  opacity: .7;\n  width: 160px;\n  height: 160px;\n  margin: auto;\n}\n.preview-error {\n  color: #1b2733;\n  font-size: 18px;\n  margin: 8px;\n}\n.preview-error-info {\n  color: #637282;\n}\n.preview-error-info span {\n  margin: 0 8px;\n}\n.can-not-preview button {\n  margin: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
